import React, {useState} from 'react';
import PropTypes from 'prop-types';

import GDPRHint from '../GDPRHint';

import { FormattedMessageWrappedInSpan } from '../../misc';
import {Checkbox, FormControl, FormControlLabel, Snackbar, Box} from '@material-ui/core';

// import { getMockImgUrl } from '../../../utils/dev';

function FaceRecognitionUpload(props) {

  const [privacyPolicyAgreed, setPrivacyPolicyAgreed] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);


  const uploadPhotoChange = (e) => {
    props.onChange(e);
  }

  const handleClickOpen = () => {
    privacyPolicyAgreed || setShowSnackbar(true);
  };
  
  const acceptPrivacyPolicy = (e) => {
    setPrivacyPolicyAgreed(!privacyPolicyAgreed);
    privacyPolicyAgreed || setShowSnackbar(false);
  }

  return (
    <>
    <div className="face-recognition-upload-container">
      <div className="startnumber-search-label">
        <FormattedMessageWrappedInSpan
          id="FaceRecognitionUpload.searchLabel"
          defaultMessage="Make a selfie or upload a photo of you"
        />
      </div>
      <div className="face-recognition-file-upload">
        <div className="face-recognition-img">
          {props.imgSrc !== null && props.imgSrc !== undefined ? (
            <img src={props.imgSrc} />
          ) : (
            <span />
          )}
        </div>
          {privacyPolicyAgreed ? (
            <input id={props.elementId} type="file" accept="image/*" onChange={uploadPhotoChange} />
          ) : (
            <input onClick={handleClickOpen} />
          )}
        </div> 
        <Box ml={2}>
        <FormControl component="fieldset">
        <FormControlLabel
          value="end"
            control={<Checkbox onChange={acceptPrivacyPolicy}/>}
          label={<GDPRHint className="mb-10" faceNote={true} />}
          labelPlacement="end"
          />
          </FormControl>
        </Box>
      </div>
      <Snackbar
        open={showSnackbar}
        message={
          <FormattedMessageWrappedInSpan
            id="FaceRecognitionUpload.agreePrivatePolicy"
            defaultMessage="Please agree our privacy policy"
          />
        }
      />
      </>
  );
}

FaceRecognitionUpload.defaultProps = {
  imgSrc: null,
  elementId: "faceRecoInput",
};

FaceRecognitionUpload.propTypes = {
  imgSrc: PropTypes.string,
  elementId: PropTypes.string,
  onChange: PropTypes.func,
};

export { FaceRecognitionUpload };

export default FaceRecognitionUpload;
